import script from "./IPDBillListTable.vue?vue&type=script&setup=true&lang=js"
export * from "./IPDBillListTable.vue?vue&type=script&setup=true&lang=js"

import "./IPDBillListTable.vue?vue&type=style&index=0&id=f5de0196&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5de0196"]])

export default __exports__